import { ReactNode } from "react";

interface OnboardingLayoutProps {
  children: ReactNode;
  imageSection?: ReactNode;
}

/**
 * Main layout wrapper for onboarding pages.
 * Provides the responsive two-column layout structure.
 */
const OnboardingLayout = ({
  children,
  imageSection,
}: OnboardingLayoutProps) => {
  return (
    <div className="OnboardingLayout relative flex min-h-full w-screen flex-col overflow-y-auto lg:flex-row">
      {/* Left content */}
      <div className="order-2 flex max-h-dvh w-full flex-grow flex-col bg-white px-6 py-6 text-black sm:px-6 lg:order-1 lg:w-1/2 lg:px-12 lg:py-12">
        {children}
      </div>

      {/* Right image section */}
      {imageSection}
    </div>
  );
};

export default OnboardingLayout;
